import React from "react";
import BannerHeader from "../../Component/Header/BannerHeader";
import Footer from "../../Component/Footer/Footer";
import "../legal.css";

const Privacy = () => {
  return (
    <>
      <BannerHeader />
      {/* Banner Section matching homepage */}
      <div
        className="container-fluid px-md-0 legal-hero"
        style={{ background: "#F1F5F8 0% 0% no-repeat padding-box" }}
      >
        <div className="row mx-auto">
          <div className="col px-0 text-center">
            <div className="bannersub">Legal</div>
            <div className="bannermain">Privacy Policy</div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div
        className="container-fluid legal-content"
        style={{ background: "#F1F5F8 0% 0% no-repeat padding-box" }}
      >
        <div className="row">
          <div className="col-xl-8 mx-auto legal-document">
            {/* Effective Date */}
            <p className="greytext pt-4">Effective Date: 19th Feb, 2025</p>

            {/* Privacy Policy Intro */}
            <p className="backtohome">
              This Privacy Policy describes how Simule (“we,” “us,” or “our”)
              collects, uses, stores, and protects your personal information
              when you access or use our website, platform, and services
              (collectively, the “Platform”). By using our Platform, you
              consent to the practices outlined in this Privacy Policy.
            </p>

            {/* Privacy Policy Sections */}
            <section className="mb-5">
              <h2 className="homepagebold">1. Information We Collect</h2>
              <p className="backtohome">
                We collect various types of information to provide and improve
                our services, including:
              </p>
              <ul>
                <li className="backtohome">
                  <span className="backtohomebold">Personal Information:</span>{" "}
                  This includes your name, email address, phone number, and any
                  identification data provided during account registration or
                  verification.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Account Credentials:</span>{" "}
                  This includes your username, password, and other login
                  credentials necessary for accessing the Platform.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Usage Data:</span> We
                  automatically collect information such as your IP address,
                  browser type, device details, pages visited, and the duration
                  of your interactions with the Platform.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Blockchain Data:</span> We
                  may collect public wallet addresses and transaction records
                  stored on the blockchain related to your use of SDL tokens
                  and digital asset transactions.
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">2. How We Use Your Information</h2>
              <p className="backtohome">
                We use your information for the following purposes:
              </p>
              <ul>
                <li className="backtohome">
                  <span className="backtohomebold">Providing and Improving Services:</span>{" "}
                  To operate, maintain, and enhance the functionality of our
                  Platform.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Transaction Processing:</span>{" "}
                  To facilitate and verify transactions related to the
                  minting, buying, selling, and trading of SDL tokens.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">User Verification:</span> To
                  authenticate users and prevent fraudulent or unauthorized
                  activities.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Customer Support:</span> To
                  respond to inquiries, provide technical assistance, and
                  address issues.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Compliance:</span> To meet
                  legal obligations, enforce our Terms & Conditions, and
                  comply with regulatory requirements.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Marketing and Communications:</span>{" "}
                  To send newsletters, updates, and promotional materials. You
                  can opt out of these communications at any time.
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">3. How We Share Your Information</h2>
              <p className="backtohome">
                We may share your information in the following circumstances:
              </p>
              <ul>
                <li className="backtohome">
                  <span className="backtohomebold">Service Providers:</span> We
                  work with trusted third-party providers who assist in
                  operating our Platform, including hosting, analytics, and
                  payment processing.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Legal and Regulatory Authorities:</span>{" "}
                  We may disclose information when required by law,
                  regulation, or legal process.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Business Transfers:</span>{" "}
                  In the event of a merger, acquisition, or sale of assets,
                  your data may be transferred as part of the business
                  transaction.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Blockchain Transparency:</span>{" "}
                  Transactions on the blockchain are public, but we do not
                  associate them with your personal information unless
                  necessary for verification.
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">4. Data Security</h2>
              <p className="backtohome">
                We implement a range of security measures to protect your
                personal data from unauthorized access, alteration,
                disclosure, or destruction. However, no system can guarantee
                absolute security, and you acknowledge the inherent risks of
                online data transmission.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">5. Data Retention</h2>
              <p className="backtohome">
                We retain your personal information for as long as necessary
                to fulfill the purposes described in this Privacy Policy or as
                required by law. When no longer needed, we securely delete or
                anonymize the data.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">6. Your Rights and Choices</h2>
              <p className="backtohome">
                You have certain rights regarding your personal information,
                including:
              </p>
              <ul>
                <li className="backtohome">
                  <span className="backtohomebold">Access and Correction:</span>{" "}
                  You may access, review, and update your personal details.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Opt-Out:</span> You can opt
                  out of receiving marketing emails by following the
                  unsubscribe link provided in our communications.
                </li>
                <li className="backtohome">
                  <span className="backtohomebold">Data Portability and Deletion:</span>{" "}
                  You may request to transfer or delete your data, subject to
                  applicable laws.
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">7. Cookies and Tracking Technologies</h2>
              <p className="backtohome">
                We use cookies and similar technologies to enhance user
                experience and collect usage data. You can manage or disable
                cookies in your browser settings, but doing so may affect the
                Platform’s functionality.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">8. International Data Transfers</h2>
              <p className="backtohome">
                Your personal information may be processed and stored in
                countries outside your residence, which may have different
                data protection laws. By using our Platform, you consent to
                this transfer.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">9. Children’s Privacy</h2>
              <p className="backtohome">
                The Platform is not intended for individuals under 18. We do
                not knowingly collect personal information from children under
                18. If such data is found to be collected inadvertently, please
                contact us for immediate removal.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">10. Changes to This Privacy Policy</h2>
              <p className="backtohome">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or legal requirements. Any
                significant updates will be communicated via the Platform or
                email. Continued use of the Platform after changes indicates
                your acceptance of the revised policy.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="homepagebold">11. Contact Information</h2>
              <p className="backtohome">
                If you have any questions or concerns about this Privacy
                Policy, please contact us:
              </p>
              <ul>
                <li className="backtohome">
                  Email: rajasekar@simule.com
                </li>
                <li className="backtohome">
                  Address: 447 Broadway, 2nd Floor Suite #1458, New York, New
                  York 10013, United States
                </li>
              </ul>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
